import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS, TAB_KEYS } from '../constants';
import { fetchDashboardTasks } from './use-dashboard-tasks';

import type { IDashboardFilters, TabKey } from '../types';

const TAB_LIST: TabKey[] = [
  TAB_KEYS.OPEN_POOL,
  TAB_KEYS.ASSIGNED_TO_ME,
  TAB_KEYS.COMPLETED,
];

const fetchTabCounts = async (
  filters: Omit<IDashboardFilters, 'tab'>,
): Promise<Record<TabKey, number>> => {
  const results = await Promise.all(
    TAB_LIST.map(async (tab) => {
      const data = await fetchDashboardTasks({ ...filters, tab });
      return [tab, data.total] as const;
    }),
  );
  return Object.fromEntries(results) as Record<TabKey, number>;
};

export function useTabCounts(filters: Omit<IDashboardFilters, 'tab'>) {
  return useQuery({
    queryKey: [QUERY_KEYS.dashboardTasks, 'tabCounts', filters],
    queryFn: () => fetchTabCounts(filters),
    refetchInterval: 30000,
    staleTime: 15000,
    refetchIntervalInBackground: false,
  });
}
